<template>
  <div class="modal-backdrop">
    <div class="modal">
      <header class="modal-header">
        <slot name="header">
          <p class="h2">{{headerMessage}}</p>
          <button type="button" class="btn-close" @click="close">x</button>
        </slot>
      </header>
      <section class="modal-body">
        <slot name="body" >
            <div v-html="bodyMessage"></div>
          <br>
        </slot>
      </section>
      <footer class="modal-footer">
        <slot name="footer">
          <a @click="close" class="button content-type-featured">Close</a>
        </slot>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal",
  props: {
    bodyMessage: String,
    headerMessage: String
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  border-top: 10px solid #0f4d90;
}

.modal-header,
.modal-footer {
  padding: 10px;
  display: flex;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  color: #2176d2;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
  text-align: center;
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #0f4d90;
  background: transparent;
}
</style>
